import React from 'react'
import transportation from '../img/transportation.png';
import building from '../img/building.png';
import healthcare from '../img/healthcare.png';
import automobile from '../img/automobile.png';
import electrical from '../img/electrical.png';
import metal_furniture from '../img/metal_furniture.png';
import aerospace from '../img/aerospace.png';
import agriculture from '../img/agriculture.png';
import industrial_engineering from '../img/industrial_engineering.png';
import architecture from '../img/architecture.png';
import interior_designing from '../img/interior_designing.png';

export default function IndustriesServe() {
  return (
    <>
      <section id="industry" className="services">
        <div className="container" style={{opacity: "1",paddingBottom: "20px"}}>
  
          <div className="section-title">
            <h3>Industries<br />
            <span>We Serve</span></h3>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={industrial_engineering} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Industiral Engineering</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={agriculture} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Agriculture</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={aerospace} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Aerospace</h6>
                </div>
              </div>
            </div>
          
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={electrical} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Electrical</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={automobile} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Automobile</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={building} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Construction</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={healthcare} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Medical & Health Care</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={architecture} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Architecture</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={interior_designing} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Interior Designing</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={metal_furniture} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Metal Furniture</h6>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" style={{opacity : "1"}}>
              <div className="card">
                <div className="icon-wrapper">
                  <img src={transportation} style={{width:"90%"}}/>
                </div>
                <div className="card-content">
                  <h6>Railways Coach Component</h6>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </section> 
    </>
  )
}
